import React from "react";
import { Redirect } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff, faUser, faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { Header, ButtonIcon, Sidebar } from "ui-kit-ck-consultant";
import Icon from "../images/pilotagereseau.svg";

import AuthContext from "../context/AuthContext";

import axiosConfig from "../utils/axiosConfig";

// The menu arrives ready to render, in `this.props.sidebar` — built from the page
// registry in permissions/routesSidebar.js. This layout no longer knows which pages
// exist, nor which flag gates them.
export default class DashboardLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarReduce: false,
      sidebarMobile: window.innerWidth < 640,
      logo: null,
    };
    this.sidebarRef = React.createRef();
  }

  static contextType = AuthContext;

  componentDidMount() {
    this.getCompanyIcon();
  }

  handleSignOutClick = () => {
    axiosConfig("/auth/signout").then((res) => {
      document.location.reload();
    });
  };

  getCompanyIcon = () => {
    let logo = localStorage.getItem("logoCompany");
    let company = localStorage.getItem("idCompany");
    if (!logo || parseInt(company) !== parseInt(this.context.companyId)) {
      axiosConfig({
        url: "/auth/get-logo",
        data: {
          companyId: this.context.companyId,
        },
      }).then((res) => {
        if (res.data.success === true) {
          localStorage.setItem("logoCompany", res.data.data);
          localStorage.setItem("idCompany", this.context.companyId);
          this.setState({ logo: res.data.data });
        } else {
          this.setState({ logo: null });
        }
      });
    } else if (logo) {
      this.setState({ logo });
    }
  };

  render() {
    if (this.props.connected === false) {
      return <Redirect to="/signin" />;
    } else {
      return (
        <div className="Dashboard-container">
          <Sidebar
            icon={Icon}
            picture={this.context.picture ? this.context.picture : null}
            ref={this.sidebarRef}
            location={this.props.location}
            onHide={(result) => this.setState({ sidebarReduce: result })}
            checkIfMobile={(isMobile) => this.setState({ sidebarMobile: isMobile })}
            views={this.props.sidebar}
            // A page the company can see but not open stays clickable on purpose:
            // that click is how the user reaches the "request access" form.
            allowDisabledClick={true}
            onViewChange={(result) => {
              this.props.history.push(result.path);
            }}
            title={this.context.name}
            subtitle={
              this.props.companyId === null
                ? "Administrateur Général"
                : this.props.admin
                ? "Administrateur"
                : ""
            }
          />
          <div className="Dashboard-container-body">
            <Header logo={this.state.logo} height="42">
              {this.state.sidebarMobile ? (
                <ButtonIcon
                  onClick={() => {
                    this.sidebarRef.current.handleHideClick();
                  }}
                >
                  <FontAwesomeIcon icon={faEllipsisV} />
                </ButtonIcon>
              ) : null}
              <ButtonIcon
                style={{ color: "#ffffff" }}
                onClick={() => this.props.history.push("/settings")}
              >
                <FontAwesomeIcon icon={faUser} />
              </ButtonIcon>
              <ButtonIcon
                style={{ color: "#ffffff" }}
                onClick={() => this.handleSignOutClick()}
              >
                <FontAwesomeIcon icon={faPowerOff} />
              </ButtonIcon>
            </Header>
            <div className="Dashboard-content">
              {this.props.connected === true ? this.props.children : ""}
            </div>
          </div>
        </div>
      );
    }
  }
}
